import React from "react";
import {
  SEO,
  PageLayout,
  HeroElement,
  Content,
  InternalLink,
  Contact,
} from "@bluefin/components";
import { Grid, Card } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getPageHeroImage } from "../utils/utils";

export default class IndexPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getPageHeroImage({
            options: fishermanBusinessWebsitePage.components,
          })}
        />
        <PageLayout
          hero={
            <HeroElement
              header={"Law Practice of Josephine A. Doyle"}
              tagline={""}
              images={getPageHeroImage({
                options: fishermanBusinessWebsitePage.components,
              })}
              ctas={[]}
              ctaInverted={true}
              ctaColor={"white"}
              containerColor={"primary"}
              textColor={"white"}
              showMultiple={true}
              overlay={true}
              fullWidth={true}
              parallax={false}
              containerAs={"none"}
              height={500}
              gutter={false}
            />
          }
          subfooter={false}
        >
          <Grid
            stackable={true}
            className={"component-section-container"}
            verticalAlign={"middle"}
            textAlign={"center"}
          >
            <Grid.Column width={16} textAlign={"center"}>
              <Content>
                <Content.Markup>
                  {fishermanBusiness.aboutMarkdown}
                </Content.Markup>
              </Content>
            </Grid.Column>
            <Grid.Column width={16} textAlign={"center"}>
              <Content>
                <Content.Markup isMarkdown={false}>
                  <Grid
                    stackable={true}
                    verticalAlign={"middle"}
                    textAlign={"center"}
                  >
                    <Grid.Row>
                      <Grid.Column width={4}>
                        <Card
                          color={"blue"}
                          to={"/areas-of-law#Trusts and Estates"}
                          as={InternalLink}
                        >
                          <Card.Content color={"blue"}>
                            <h3>Trusts and Estates</h3>
                          </Card.Content>
                        </Card>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Card
                          color={"blue"}
                          to={"/areas-of-law#Real Estate"}
                          as={InternalLink}
                        >
                          <Card.Content color={"blue"}>
                            <h3>Real Estate</h3>
                          </Card.Content>
                        </Card>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Card
                          color={"blue"}
                          to={"/areas-of-law#Guardianship"}
                          as={InternalLink}
                        >
                          <Card.Content color={"blue"}>
                            <h3>Guardianship</h3>
                          </Card.Content>
                        </Card>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={4}>
                        <Card
                          color={"blue"}
                          to={"/areas-of-law#Estate Planning"}
                          as={InternalLink}
                        >
                          <Card.Content color={"blue"}>
                            <h3>Estate Planning</h3>
                          </Card.Content>
                        </Card>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Card
                          color={"blue"}
                          to={"/areas-of-law#Medicaid Applications"}
                          as={InternalLink}
                        >
                          <Card.Content color={"blue"}>
                            <h3>Medicaid Applications</h3>
                          </Card.Content>
                        </Card>
                      </Grid.Column>
                      <Grid.Column width={4}>
                        <Card
                          color={"blue"}
                          to={"/areas-of-law#Immigration Law"}
                          as={InternalLink}
                        >
                          <Card.Content color={"blue"}>
                            <h3>Immigration</h3>
                          </Card.Content>
                        </Card>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Content.Markup>
              </Content>
            </Grid.Column>
          </Grid>
          <Grid stackable={true} className={"component-section-container"}>
            <Grid.Column width={16}>
              <Contact
                businessName={fishermanBusiness.name}
                phoneNumber={fishermanBusiness.primaryLocation.phoneNumber}
                email={fishermanBusiness.primaryLocation.email}
                hours={fishermanBusiness.primaryLocation.hours}
                address={{
                  street: fishermanBusiness.primaryLocation.street,
                  city: fishermanBusiness.primaryLocation.city,
                  state: fishermanBusiness.primaryLocation.state,
                  zip: fishermanBusiness.primaryLocation.zipCode,
                }}
                as={"text"}
                buttonColor={"secondary"}
                header={"Contact"}
                image={""}
                showMap={true}
              />
            </Grid.Column>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
      aboutMarkdown
      primaryLocation {
        phoneNumber
        email
        hours {
          open
          close
          label
          day
        }
        street
        city
        state
        zipCode
      }
    }
    fishermanBusinessWebsitePage(title: { eq: "Home" }) {
      title
      components {
        fastId
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
